import { FileUpload } from "primereact/fileupload";
import { CommonDialog } from "../../common/CommonDialog";
import { useState } from "react";
import { useTranslation } from "react-i18next";

export function InsertImageDialog({visible,onOK,onCancel})
{
    const {t} = useTranslation(); 
    const [img,setImg]=useState(null);

    const uploadHandler = (event)=>{
        console.log(event.files);
        setImg(event.files[0]);
    };
    const emptyTemplate=()=>{
        return (
            <div className="flex align-items-cemter col">
                <i className="pi pi-image mt-3 p-5" style={{'fontSize': '5em', borderRadius: '50%', backgroundColor: 'var(--surface-b)', color: 'var(--surface-d)'}}></i>
                <span style={{'fontSize': '1.2em', color: 'var(--text-color-secondary)'}} className="my-5">{t('Editor.Drag_and_drop_image_here')}</span>
            </div>
        )
    };
    const chooseOptions = {label: t('Editor.Choose'), icon: 'pi pi-fw pi-plus'};
    const uploadOptions = {};
    const cancelOptions = {};

    const _onOK=(e)=>{
        if (!img) 
			return;
		var reader = new FileReader();
		reader.onload = function(e) {
			var contents = reader.result;
			console.log('buffer length:'+contents.length);
			//var insertImageFileData = btoa(contents);
            //onOK(img,insertImageFileData);
            onOK(img,contents);
        }
        //reader.readAsBinaryString(img);
        reader.readAsArrayBuffer(img);
    };
    const _onCancel=(e)=>{
        onCancel();
    };
    return(
        <>
            <CommonDialog header={t('Editor.Insert_Image')} onOK={_onOK} onCancel={_onCancel} visible={visible}>
                <FileUpload name="image" mode="advanced" auto
                    multiple={false} emptyTemplate={emptyTemplate} chooseOptions={chooseOptions} 
                    uploadOptions={uploadOptions} cancelOptions={cancelOptions} customUpload uploadHandler={uploadHandler}/> 
            </CommonDialog>                 
        </>
    );
}